var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { EventEmitter, OnInit } from '@angular/core';
import { ToasterService } from 'src/app/toaster.service';
import { Toaster, ToasterType, Table, Pagination } from 'src/app/shared/types';
import { CustomerInvoiceReceiptRequestsService } from './customer-invoice-receipt-requests.service';
import { environment } from 'src/environments/environment';
var DEFAULT_CONSTRAINTS = {
    maxLookbackDays: 365,
    maxRangeDays: 90,
    defaultRangeDays: 7,
};
var MAX_EMAIL_LENGTH = 254;
var CustomerInvoiceReceiptRequestsComponent = /** @class */ (function () {
    function CustomerInvoiceReceiptRequestsComponent(toasterService, invoiceReceiptRequestsService) {
        this.toasterService = toasterService;
        this.invoiceReceiptRequestsService = invoiceReceiptRequestsService;
        this.toggleHeaders = new EventEmitter();
        this.email = '';
        this.validationError = '';
        this.submitting = false;
        this.constraints = DEFAULT_CONSTRAINTS;
    }
    CustomerInvoiceReceiptRequestsComponent.prototype.ngOnInit = function () {
        var cfg = {};
        var envAny = environment;
        if (envAny && envAny.invoiceReceiptRequest) {
            cfg = envAny.invoiceReceiptRequest;
        }
        this.constraints = {
            maxLookbackDays: Math.max(1, Number(cfg.maxLookbackDays) || DEFAULT_CONSTRAINTS.maxLookbackDays),
            maxRangeDays: Math.max(1, Number(cfg.maxRangeDays) || DEFAULT_CONSTRAINTS.maxRangeDays),
            defaultRangeDays: Math.max(1, Number(cfg.defaultRangeDays) || DEFAULT_CONSTRAINTS.defaultRangeDays),
        };
        this.email = this.customerEmail || '';
        this.initHeader();
        this.initDates();
        this.recomputeBoundsAndValidate();
    };
    CustomerInvoiceReceiptRequestsComponent.prototype.changeInHeader = function (header) {
        this.toggleHeaders.emit(header);
    };
    CustomerInvoiceReceiptRequestsComponent.prototype.initHeader = function () {
        this.headerTable = new Table({
            toggleableHeaders: this.customerDetailsToggleableHeaders,
            selectedHeader: 6,
            headers: {},
            data: [],
            pagination: new Pagination(null, null, null, null, 0, false),
            defaultError: '',
        });
    };
    CustomerInvoiceReceiptRequestsComponent.prototype.initDates = function () {
        var now = new Date();
        var from = new Date(now);
        var defaultRangeDays = Math.min(this.constraints.defaultRangeDays, this.constraints.maxRangeDays);
        from.setDate(from.getDate() - defaultRangeDays);
        this.fromDate = from;
        this.toDate = now;
    };
    CustomerInvoiceReceiptRequestsComponent.prototype.onFromDateChange = function () {
        var prevError = this.validationError;
        this.recomputeBoundsAndValidate();
        if (this.validationError && this.validationError !== prevError) {
            this.toasterService.showToaster(new Toaster({
                type: ToasterType.WARNING,
                message: "Invalid date range. " + this.validationError,
            }));
        }
    };
    CustomerInvoiceReceiptRequestsComponent.prototype.onToDateChange = function () {
        var prevError = this.validationError;
        this.recomputeBoundsAndValidate();
        if (this.validationError && this.validationError !== prevError) {
            this.toasterService.showToaster(new Toaster({
                type: ToasterType.WARNING,
                message: "Invalid date range. " + this.validationError,
            }));
        }
    };
    CustomerInvoiceReceiptRequestsComponent.prototype.onEmailChange = function () {
        this.recomputeBoundsAndValidate();
    };
    CustomerInvoiceReceiptRequestsComponent.prototype.getTodayDateOnly = function () {
        var now = new Date();
        return new Date(now.getFullYear(), now.getMonth(), now.getDate());
    };
    CustomerInvoiceReceiptRequestsComponent.prototype.getLookbackMinDate = function (today) {
        var maxLookbackDays = this.constraints.maxLookbackDays;
        var lookback = new Date(today);
        lookback.setDate(lookback.getDate() - (maxLookbackDays - 1));
        return lookback;
    };
    CustomerInvoiceReceiptRequestsComponent.prototype.recomputeBoundsAndValidate = function () {
        // Use date-only (local start-of-day) for bounds to avoid time-of-day off-by-one issues.
        var today = this.getTodayDateOnly();
        var lookback = this.getLookbackMinDate(today);
        // Restrict selectable dates via calendar bounds (but NEVER auto-modify user-selected dates)
        var DAY_MS = 24 * 60 * 60 * 1000;
        // Inclusive range: From day + (maxRangeDays - 1 days) = maxRangeDays total days
        var maxRangeDays = this.constraints.maxRangeDays;
        var maxRangeMs = (maxRangeDays - 1) * DAY_MS;
        // From date should always be freely selectable in [today-365, today]
        this.minFromDate = lookback;
        this.maxFromDate = today;
        // To date should be selectable only in [fromDate, min(fromDate + 90 days, today)]
        var from = this.fromDate ? new Date(this.fromDate) : null;
        if (from) {
            var maxToByFrom = new Date(from.getTime() + maxRangeMs);
            this.minToDate = from;
            this.maxToDate = new Date(Math.min(today.getTime(), maxToByFrom.getTime()));
        }
        else {
            // If from isn't selected yet, keep To constrained only by absolute bounds
            this.minToDate = lookback;
            this.maxToDate = today;
        }
        this.validationError = this.getValidationError();
    };
    CustomerInvoiceReceiptRequestsComponent.prototype.getValidationError = function () {
        if (!this.customerId)
            return 'Customer not loaded yet.';
        if (!this.fromDate || !this.toDate)
            return 'Please select both From and To dates.';
        var emailRaw = (this.email || '').trim();
        var email = emailRaw ? emailRaw.toLowerCase() : '';
        if (email) {
            if (email.length > MAX_EMAIL_LENGTH)
                return 'Invalid email.';
            if (email.indexOf('\r') !== -1 || email.indexOf('\n') !== -1)
                return 'Invalid email.';
            var EMAIL_RE = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
            if (!EMAIL_RE.test(email))
                return 'Invalid email.';
        }
        // Validate on date-only (local start-of-day)
        var todayDate = this.getTodayDateOnly();
        var today = todayDate.getTime();
        var from = new Date(this.fromDate.getFullYear(), this.fromDate.getMonth(), this.fromDate.getDate()).getTime();
        var to = new Date(this.toDate.getFullYear(), this.toDate.getMonth(), this.toDate.getDate()).getTime();
        if (!Number.isFinite(from) || !Number.isFinite(to))
            return 'Invalid dates selected.';
        if (to > today)
            return 'To date cannot be in the future.';
        var lookback = this.getLookbackMinDate(todayDate);
        if (from < lookback.getTime())
            return "From date cannot be older than " + this.constraints.maxLookbackDays + " days.";
        if (from > to)
            return 'To date must be on/after From date.';
        var maxRangeDays = this.constraints.maxRangeDays;
        // Inclusive range: allow up to maxRangeDays total => to-from <= (maxRangeDays-1) days in ms (when dates are date-only)
        var maxRangeMs = (maxRangeDays - 1) * 24 * 60 * 60 * 1000;
        if ((to - from) > maxRangeMs)
            return "Requested range cannot exceed " + maxRangeDays + " days.";
        return '';
    };
    CustomerInvoiceReceiptRequestsComponent.prototype.submit = function () {
        return __awaiter(this, void 0, void 0, function () {
            var fromD, toD, from, to, emailRaw, email;
            var _this = this;
            return __generator(this, function (_a) {
                this.recomputeBoundsAndValidate();
                if (this.validationError) {
                    this.toasterService.showToaster(new Toaster({
                        type: ToasterType.WARNING,
                        message: this.validationError,
                    }));
                    return [2 /*return*/];
                }
                fromD = new Date(this.fromDate.getFullYear(), this.fromDate.getMonth(), this.fromDate.getDate());
                toD = new Date(this.toDate.getFullYear(), this.toDate.getMonth(), this.toDate.getDate());
                from = fromD.getTime();
                to = toD.getTime();
                emailRaw = (this.email || '').trim();
                email = emailRaw ? emailRaw.toLowerCase() : '';
                this.submitting = true;
                this.invoiceReceiptRequestsService
                    .raiseBulkInvoiceReceiptRequest(this.customerId, from, to, email)
                    .subscribe(function (result) {
                    _this.submitting = false;
                    var message = (result && (result.message || result.metadata || result)) || 'Request submitted.';
                    _this.toasterService.showToaster(new Toaster({
                        type: ToasterType.SUCCESS,
                        message: typeof message === 'string' ? message : 'Request submitted.',
                    }));
                }, function (err) {
                    _this.submitting = false;
                    _this.toasterService.showToaster(new Toaster({
                        type: ToasterType.WARNING,
                        message: (err && err.error && err.error.message) || 'Unable to submit request.',
                    }));
                });
                return [2 /*return*/];
            });
        });
    };
    return CustomerInvoiceReceiptRequestsComponent;
}());
export { CustomerInvoiceReceiptRequestsComponent };
